import React from 'react';
import { Spin } from 'antd';
import { maths } from '../../../utils';
import './index.less';
/** canvas大小 */
const WIDTH = 700;
const HEIGHT = 500;
let timeRecord = null;
let timer = (time = 0, method = 'block') => {
  timeRecord = setTimeout(() => {
    let dom = document.querySelector('.viewer-tooltip');
    if (dom) {
      dom.style.display = method;
    }
  }, time);
};

const CanvasComponent = ({ imgSrc }) => {
  const canvasRef = React.useRef(null);

  const [imgX, setImgX] = React.useState(0);
  const [imgY, setImgY] = React.useState(0);
  const [imgScale, setImgScale] = React.useState(1);
  const [mouseDownPos, setMouseDownPos] = React.useState({ x: 0, y: 0 });
  const [mouseDownFlag, setMouseDownFlag] = React.useState(false);
  const [mouseUpFlag, setMouseUpFlag] = React.useState(false);
  const [imgElement, setImgElement] = React.useState(new Image());

  React.useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    // 进行canvas绘制操作
    const img = new Image();
    img.width = WIDTH;
    img.height = HEIGHT;
    img.src = imgSrc;
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
    };
    setImgElement(img);
  }, [imgSrc]); // 确保这个effect只在组件挂载时执行一次

  const drawImage = (imgX, imgY, imgScale) => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.drawImage(
      imgElement, //规定要使用的图像、画布或视频。
      0,
      0, //开始剪切的 x 坐标位置。
      imgElement.width,
      imgElement.height, //被剪切图像的高度。
      imgX,
      imgY, //在画布上放置图像的 x 、y坐标位置。
      imgElement.width * imgScale,
      imgElement.height * imgScale, //要使用的图像的宽度、高度
    );
  };

  /** 图片平移 */
  const handleMouseDown = (event) => {
    event.stopPropagation();
    event.preventDefault(); // 阻止浏览器默认行为，拖动会打开图片
    const { clientX, clientY } = event;
    // 相对于canvas坐标
    const canvas = canvasRef.current;
    const pos = windowToCanvas(clientX, clientY);
    canvas.style.cursor = 'move';
    setMouseDownFlag(true); // 控制只有在鼠标按下后才会执行mousemove
    setMouseDownPos({
      x: pos.x,
      y: pos.y,
    });
  };

  const handleMouseMove = (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (!mouseDownFlag) return;
    const canvas = canvasRef.current;
    canvas.style.cursor = 'move';
    const { clientX, clientY } = event;
    let posl = windowToCanvas(clientX, clientY);
    let x = posl.x - mouseDownPos.x;
    let y = posl.y - mouseDownPos.y;
    let imgX1 = imgX + x;
    let imgY1 = imgY + y;
    drawImage(imgX1, imgY1, imgScale);
    setImgX(imgX1);
    setImgY(imgY1);
    setMouseDownPos({
      x: posl.x,
      y: posl.y,
    });
  };

  const handleMouseUp = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const canvas = canvasRef.current;
    canvas.style.cursor = '-webkit-grab' || 'grab';
    setMouseDownFlag(false);
    setMouseUpFlag(true); // 鼠标抬起说明鼠标已经按下
  };

  /*坐标转换*/
  const windowToCanvas = (x, y) => {
    let canvas = canvasRef.current;
    let box = canvas.getBoundingClientRect();
    return {
      x: x - box.left - (box.width - canvas.width) / 2,
      y: y - box.top - (box.height - canvas.height) / 2,
    };
  };

  const handleWheelImage = (event) => {
    event.stopPropagation();
    if (!mouseUpFlag) return;
    clearTimeout(timeRecord);
    timer();
    let pos = windowToCanvas(event.clientX, event.clientY);
    let n = 1.1;
    let n2 = (1 / 1.1).toFixed(2);
    const bigger = event.deltaY > 0 ? -1 : 1;
    let imgScale1 = imgScale;
    let imgX1 = imgX;
    let imgY1 = imgY;
    if (bigger > 0) {
      imgScale1 *= n;
      imgX1 = imgX * n - pos.x * (n - 1);
      imgY1 = imgY * n - pos.y * (n - 1);
    } else {
      imgScale1 *= n2;
      imgX1 = imgX * n2 + pos.x * (1 - n2);
      imgY1 = imgY * n2 + pos.y * (1 - n2);
    }
    drawImage(imgX1, imgY1, imgScale1);
    setImgX(imgX1);
    setImgY(imgY1);
    setImgScale(imgScale1);
    timer(2000, 'none');
  };
  return (
    <div className="imgArea">
      <canvas
        ref={canvasRef}
        width={WIDTH}
        height={HEIGHT}
        onWheel={handleWheelImage}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        className="pointerZoom"
        title="点击图纸后操作鼠标可以缩放图纸"
      />
      <div className="viewer-tooltip viewer-move">{maths.mul(imgScale, 100).toFixed(0) + '%'}</div>
    </div>
  );
};

export default CanvasComponent;
